import React, { useState, useEffect, useRef } from 'react'
import styles from '../../../styles/HomeLanding/IndiaLandingPage.module.css'
import Image from 'next/image'
import { MarqueeComponentHomePage, NewMarqueeComponentHomePageIndia } from '@/components/qbStrap'
import { Button } from 'reactstrap'
import VerificationPopup from '@/components/modals/VerificationPopup'
import { MdHeight } from 'react-icons/md'

const TopSection = () => {
    const [countriesText, setCountriesText] = useState('0 Az+');
    const [billingSpeedText, setBillingSpeedText] = useState('00%');
    const [hasAnimated, setHasAnimated] = useState(false);
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [contactSales, setContactSales] = useState(false);
    const sectionRef = useRef(null);

    const animateNumber = (setter, initialText, finalText, specialChars = ['%', ' ', '+']) => {
        const numbers = '0123456789'
        const uppercaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
        const lowercaseLetters = 'abcdefghijklmnopqrstuvwxyz'
        const symbols = '-x'
        let iterations = 0

        const interval = setInterval(() => {
            setter(current => {
                return current
                    .split('')
                    .map((char, index) => {
                        if (index < iterations) {
                            return finalText[index]
                        }

                        if (specialChars.includes(char) || specialChars.includes(finalText[index])) {
                            return finalText[index]
                        }

                     
                        if (uppercaseLetters.includes(finalText[index])) {
                            return uppercaseLetters[Math.floor(Math.random() * uppercaseLetters.length)]
                        }

                      
                        if (lowercaseLetters.includes(finalText[index])) {
                            return lowercaseLetters[Math.floor(Math.random() * lowercaseLetters.length)]
                        }

                        
                        if (numbers.includes(finalText[index])) {
                            return numbers[Math.floor(Math.random() * numbers.length)]
                        }
                        return char
                    })
                    .join('')
            })

            iterations += 1 / 10

            if (iterations >= finalText.length) {
                clearInterval(interval)
                setter(finalText)
            }
        }, 100)

        return () => clearInterval(interval)
    }

    const startAnimation = () => {
        if (hasAnimated) return;
        setHasAnimated(true);
        animateNumber(setCountriesText, '0 Az+', '4 Mn+');
        animateNumber(setBillingSpeedText, '00%', '60%');
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    startAnimation();
                    observer.disconnect();
                }
            },
            { threshold: 0.3 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);
   
    const CompanyLogos = [
    { imgSrc: "/assets/HomeLanding/QBIcons/heineken.svg", height:"10rem",width:"15rem", altText: "Heineken" },
    { imgSrc: "/assets/HomeLanding/QBIcons/bridgestone.svg",height:"10rem",width:"15rem", altText: "Bridgestone" },
    { imgSrc: "/assets/HomeLanding/QBIcons/itc.svg",height:"10rem",width:"15rem", altText: "ITCLimited" },
    { imgSrc: "/assets/HomeLanding/QBIcons/tajseats.svg",height:"10rem",width:"15rem", altText: "TajSats1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/irctc.svg",height:"10rem",width:"15rem",  altText: "irctc" },
    { imgSrc: "/assets/HomeLanding/QBIcons/cremica.svg",height:"10rem",width:"15rem",  altText: "Cremica" },
    { imgSrc: "/assets/HomeLanding/QBIcons/pansarigroup.svg",height:"10rem",width:"15rem",  altText: "PansariGroup" },
    { imgSrc: "/assets/HomeLanding/QBIcons/reshamandi.svg",height:"10rem",width:"15rem",  altText: "Reshamandi1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/selectcitywalk.svg",height:"10rem",width:"15rem", altText: "SelectCitywalk" },
    { imgSrc: "/assets/HomeLanding/QBIcons/cococart.svg",height:"10rem",width:"15rem", altText: "Cococart" },
    { imgSrc: "/assets/HomeLanding/QBIcons/emoi.svg",height:"10rem",width:"15rem", altText: "Emoi" },
    { imgSrc: "/assets/HomeLanding/QBIcons/candorfoods.svg",height:"10rem",width:"15rem",  altText: "CandorFoods" },
    { imgSrc: "/assets/HomeLanding/QBIcons/TirumalaTirupatiDevasthanams.svg",height:"10rem",width:"15rem",  altText: "TirumalaTirupatiDevasthanams" },
    { imgSrc: "/assets/HomeLanding/QBIcons/earthrhythm.svg",height:"10rem",width:"15rem",  altText: "ArthRhythm1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/hindustanunilever.svg",height:"10rem",width:"15rem",  altText: "HindustanUnileverLimited" },
    { imgSrc: "/assets/HomeLanding/QBIcons/genus.svg",height:"10rem",width:"15rem", altText: "Genus" },
    { imgSrc: "/assets/HomeLanding/QBIcons/dlfbrands.svg",height:"10rem",width:"15rem", altText: "DLFbrands" },
    { imgSrc: "/assets/HomeLanding/QBIcons/bayarscoffee.svg",height:"10rem",width:"15rem",  altText: "scoffee" },
    { imgSrc: "/assets/HomeLanding/QBIcons/continentalcoffee.svg",height:"10rem",width:"15rem", altText: "Continentalcoffee" },
    { imgSrc: "/assets/HomeLanding/QBIcons/plazalounge.svg",height:"10rem",width:"15rem", altText: "Plazapremiumlounge" },
    { imgSrc: "/assets/HomeLanding/QBIcons/mmmart.svg",height:"10rem",width:"15rem", altText: "Mart" },
    { imgSrc: "/assets/HomeLanding/QBIcons/wonderla.svg",height:"10rem",width:"15rem", altText: "wonderla" },

    { imgSrc: "/assets/HomeLanding/QBIcons/shivalaya1.svg",height:"10rem",width:"15rem", altText: "Shivalaya 1" },
    
   
]
const companyLogos2= [
     { imgSrc: "/assets/HomeLanding/QBIcons/organicharvest.svg", width:"15rem", height:"10rem", altText: "OrganicHarvest" },
    { imgSrc: "/assets/HomeLanding/QBIcons/nayara.svg",width:"15rem", height:"10rem", altText: "NayaraEnergy" },
    { imgSrc: "/assets/HomeLanding/QBIcons/premier.svg",height:"10rem",width:"15rem", altText: "Premier1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/orgalife.svg",height:"10rem",width:"15rem", altText: "Orgalife1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/smytten.svg",height:"10rem",width:"15rem", altText: "Smytten1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/flemingo.svg",height:"10rem",width:"15rem", altText: "Flemingo1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/aafarin.svg",height:"10rem",width:"15rem", altText: "Aafarin" },
    { imgSrc: "/assets/HomeLanding/QBIcons/redivy.svg",height:"10rem",width:"15rem", altText: "RedIvy1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/toscee.svg",height:"10rem",width:"15rem",  altText: "Toscee1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/jainshikanji.svg",height:"10rem",width:"15rem", altText: "Jainshikanji" },
    { imgSrc: "/assets/HomeLanding/QBIcons/34chowringlane.svg",height:"10rem",width:"15rem", altText: "34chowringheelane" },
    { imgSrc: "/assets/HomeLanding/QBIcons/tangelo.svg",height:"10rem",width:"15rem", altText: "Tangelo1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/canabeans.svg",height:"10rem",width:"15rem", altText: "Canabeans1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/thegulatigroup.svg",height:"10rem",width:"15rem",altText: "gulatigroup" },
    { imgSrc: "/assets/HomeLanding/QBIcons/gullynetwork.svg", height:"10rem",width:"15rem", altText: "Gullynetwork1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/mcd.svg",height:"10rem",width:"15rem", altText: "MCD1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/phl.svg",height:"10rem",width:"15rem", altText: "PHL1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/tistabene.svg",height:"10rem",width:"15rem", altText: "Tistabene1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/hokmakeup.svg",height:"10rem",width:"15rem", altText: "HOKmakeup1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/bonkers.svg",height:"10rem",width:"15rem", altText: "bonkers" },
    { imgSrc: "/assets/HomeLanding/QBIcons/handfulofhealth.svg",height:"10rem",width:"15rem", altText: "Handfulofhealth" },
    { imgSrc: "/assets/HomeLanding/QBIcons/grihasthee.svg",height:"10rem",width:"15rem", altText: "grihasthee1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/almostgods.svg",height:"10rem",width:"15rem", altText: "almostgods" },
    { imgSrc: "/assets/HomeLanding/QBIcons/becafe.svg",height:"10rem",width:"15rem", altText: "Becafe" },

]
  
  return (
    <div>
           <div className={styles.verificationPopupOverride}>
            <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} contactSales={contactSales} />
           </div>
          <div className={styles.top_section}>

                <div className={styles.gradient_section}>
                    <div className={styles.gradient_blue_india}></div>
                    <div className={styles.gradient_orange_india}></div>
                </div>
                <div className={styles.top_text_section}>
                    <h1> <span className={styles.top_text_section_title}>The All-In-One Business Solution for </span> <br />
                       Seamless Billing & Unstoppable Growth</h1>
                    <p >The next-gen POS & Billing software, designed for efficient billing, inventory management,  payments, online store integration, customer loyalty programs, and more.<br /> Manage all your store operations with ease, whether online or offline.</p>
                    <Button className={styles.demoButton} style={{ width: 'fit-content' }} onClick={() => (setDemoModal(true), setHeading("Book your free demo now!"))} > <span>Get Free Demo</span></Button>
                </div>
                <div className={styles.hero_bottom_section}>
                    <div className={styles.hero_visual}>
                    <div className={styles.top_image}>
                    <Image
                        src="/assets/HomeLanding/landing-hero-img-ind1.webp"
                        width={640}
                        height={521}
                        alt="POS billing software in India"
                        sizes="530px"
                        priority
                        fetchPriority="high"
                        quality={75}
                        style={{ width: "100%", height: "auto", display: "block" }}
                    />
                    </div>
                    <div className={styles.hero_imagebottom_section} style={{position: 'relative'}} ref={sectionRef}>
                        <div className={styles.hero_imagebottom_section_info}>
                            <div className={styles.top_countries}>
                                {/* <h3>{countriesText}</h3> */}
                                <p className={styles.stat_value}>85K+ </p>
                                
                                <p>merchants trust us for empowering their business.</p>
                            </div>
                            <div className={styles.top_companies}>
                                {/* <h3>{billingSpeedText}</h3> */}
                                <p className={styles.stat_value}>60%</p>
                                <p> faster billing speed for the <br /> merchants worldwide.</p>
                            </div>
                        </div>
                        <div className={styles.gradient_TopSection}> <Image src='/assets/HomeLanding/bgGradient.svg' fill alt='POS billing software in Dubai' /> </div>
                        <div className={styles.gradient_TopSection2}> <Image src='/assets/HomeLanding/bgGradient2.svg' fill alt='POS billing software in Dubai' /> </div>

                         
                    </div>
                    </div>
                    <div style={{ margin: "5rem 18rem 0 18rem", position: "relative", zIndex:1 }}>
                            <NewMarqueeComponentHomePageIndia
                             direction={'left'}
                                ClientsArr={CompanyLogos}
                                style={{
                                    width: "100%",
                                    backgroundColor: "transparent",
                                    display: "flex",
                                    justifyContent: "center",
                                    margin: "2rem  auto 0 auto",
                                }}
                            />
                            <NewMarqueeComponentHomePageIndia
                                ClientsArr={companyLogos2}
                                  
                                style={{
                                    width: "100%",
                                    backgroundColor: "transparent",
                                    display: "flex",
                                    justifyContent: "center",
                                    margin: "-1rem auto 0 auto",
                               
        
                                }}
                            />
                        </div>
                </div>

            </div>
    </div>
  )
}

export default TopSection
